export default __webpack_public_path__ + "static/media/orderDetail_backgroundImg.5481f55d.png";